// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rp-2";
export var chatLink = "_rp-0";
export var chatText = "_rp-1";